import {
  type OfferV11,
  type VolumeBasedPriceV1,
} from '@redteclab/api/clients/bully'

export const offerAccessorGetVolumePricing = (
  offer: OfferV11 | undefined,
): VolumeBasedPriceV1[] | null => {
  if (!offer) {
    return null
  }

  return offer.volumeBasedPrices ?? null
}
